import React from "react";
import { Container, Title, Text, Button, MantineProvider } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import {Footer} from "./Footer/Footer";
import styles from "./SplashLanding.module.css";

const theme = {
  components: {
    Button: {
      styles: {
        root: {
          transition: "background-color 0.3s ease-in-out",
          "&:hover": {
            backgroundColor: "rgba(15, 45, 45, 0.75)",
            color: "white",
          },
        },
      },
    },
  },
};

function SuccessPage() {
  const navigate = useNavigate();

  return (
    <MantineProvider theme={theme}>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <Container
          size="md"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            padding: "50px 0",
          }}
        >
          <img
            src="/static/Socius_DRK.svg"
            alt="Socius Legal"
            className={styles.logo}
            style={{ marginBottom: "2rem", maxWidth: "200px" }}
          />
          <Title order={1}>Thank You for Signing Up!</Title>
          <Text size="lg" mt="md">
            We appreciate your interest in Socius Legal. We'll be in touch soon
            with more information.
          </Text>
          <Button
            onClick={() => navigate("/")}
            mt="xl"
            className={styles.getStartedBtn}
            size="md"
            style={{
              backgroundColor: "var(--accent-gold)",
              transition: "background-color 0.3s ease-in-out",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor =
                "var(--accent-gold-hover)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "var(--accent-gold)")
            }
          >
            Return to Home
          </Button>
        </Container>
        {Footer()}
      </div>
    </MantineProvider>
  );
}

export default SuccessPage;
